import {observer} from "mobx-react-lite"
import React, {useEffect} from "react"
// import priceUpdateController from "../../store/pageControllers/PriceUpdateController"
import CliApi from "../../api/CliApi"
import {TaskControls} from "../../components/task_buttons/TaskControls";
import priceUpdateController from "../../store/pageControllers/PriceUpdateController"
import {SkeletonBox, WaCheckbox} from "../../lib/wa-2.0"
import ReactPaginate from "react-paginate"


export const PriceUpdateLauncher = observer(() => {
    useEffect(() => {
        priceUpdateController.loadSettings()
    }, [])

    return <div className={"custom-mt-32"} id={'price_markup'}>


        <div className={"custom-mt-20 "}>
            <div className={"custom-mb-12"}>
                Для обновления цен добавьте команду в CRON или запустите вручную:
            </div>
            <TaskControls
                command={priceUpdateController.syncPrices}
                start={CliApi.runSyncPrice}
            />
        </div>

        <h5>Проверка цен</h5>

        <div className={"custom-mt-20 "}>
            <div className={"custom-mb-12"}>
                Чтобы визуально проверить цены в Ozon и их соответствие с сайтом нажмите кнопку
            </div>
            <button
                className={'button blue'}
                onClick={() => priceUpdateController.comparePrices(0, true)}
            >{'Запустить'}</button>
            {priceUpdateController.loadStarted && <div className="spinner" style={{margin:'10px 7px -2px 3px'}}></div>}
        </div>
        {(priceUpdateController.totalCount > -1) && <div className={"align-right custom-my-8"}>
            <input
                className={"ozon_left"}
                type={"text"}
                value={priceUpdateController.search_query}
                onChange={(e) => {
                    priceUpdateController.search_query = e.target.value
                }}/>


            <WaCheckbox
                id={'not_found'}
                checked={priceUpdateController.not_found}
                onChange={(e) => priceUpdateController.not_found = e.target.checked}
            />
            <label htmlFor={'not_found'}>Ненайденные товары</label>
            <WaCheckbox
                id={'with_diff'}
                checked={priceUpdateController.with_diff}
                onChange={(e) => priceUpdateController.with_diff = e.target.checked}
            />
            <label htmlFor={'with_diff'}>Только с различиями</label>

        </div>}
        {priceUpdateController.pricesLoaded ? <table>
            <thead style={{backgroundColor: "#F3F3F3"}}>
            <tr>
                <th>product_id </th>
                <th>offer_id</th>
                <th>Наименование товара</th>
                <th>Цена OZ</th>
                <th>Цена SS</th>
                <th>Старая цена OZ</th>
                <th>Старая цена SS</th>
            </tr>
            </thead>
            <tbody>
            {priceUpdateController.prices.map((item, index) =>
                <tr key={index}>
                    <td>{item.product_id}</td>
                    <td>{item.offer_id}</td>
                    <td>{item.product_name}</td>
                    <td>{+item.ozon_price}</td>
                    <td>{+item.shop_price}</td>
                    <td>{+item.ozon_old_price}</td>
                    <td>{+item.shop_old_price}</td>
                </tr>
            )}
            </tbody>
        </table> : priceUpdateController.totalCount === -1 ? <div></div> : <p>Не найдено</p>}
        {priceUpdateController.countOfPages > 1 &&
        <div className={'paginate-compare'}>
            <ReactPaginate
                previousLabel={'Предыдущая'}
                nextLabel={'Следующая'}
                containerClassName={'paging'}
                pageCount={priceUpdateController.countOfPages}
                pageRangeDisplayed={2}
                marginPagesDisplayed={2}
                initialPage={priceUpdateController.page}
                onPageChange={({selected}) => {
                    priceUpdateController.comparePrices(selected)
                }
                }
            />
        </div>}
    </div>
})